// TRUSTFRAME — Private View card index
// Each entry maps a slug to a sub-route. The actual rich content for each
// section lives in /app/frontend/src/components/private/sections/*.js so
// large narrative blocks stay out of this index file.

export const PRIVATE_SECTIONS = [
  {
    slug: 'manifesto',
    num: 'I',
    label: 'Manifesto',
    eyebrow: '[ .I. .MANIFESTO. ]',
    title: 'The Freedom\nto Create with Abandon',
    blurb:
      'On trust, regulation, and the liberation of art in the age of the blockchain. Five-part manifesto authored at INFINITYPAX × TrustFrame.',
    tag: 'Read',
    accent: '#f5a623',
  },
  {
    slug: 'ecosystem',
    num: 'II',
    label: 'Ecosystem',
    eyebrow: '[ .II. .ECOSYSTEM. ]',
    title: 'One protocol.\nFive companies.',
    blurb:
      'TrustFrame, Monyx.cafe, Monyx.money, Custos, Custodian — trust, money, custody, succession, transfer infrastructure for the modern wealth economy.',
    tag: 'Map',
    accent: '#a855f7',
  },
  {
    slug: 'whitepaper',
    num: 'III',
    label: 'Whitepaper',
    eyebrow: '[ .III. .WHITEPAPER. ]',
    title: 'The protocol.\nIn full.',
    blurb:
      'Four-module specification — Comply, Verify, Transact, Attest. Identity layer, settlement layer, attestation layer, fee design.',
    tag: 'Spec',
    accent: '#4da6ff',
  },
  {
    slug: 'investors',
    num: 'IV',
    label: 'Investors',
    eyebrow: '[ .IV. .INVESTORS. ]',
    title: 'The opportunity.',
    blurb:
      'Twelve-slide investor deck — problem, solution, transaction flow, market, business model, unit economics, legal structure, projections, pipeline, ask.',
    tag: 'Deck',
    accent: '#00d68f',
  },
  {
    slug: 'funding',
    num: 'V',
    label: 'Funding Strategy',
    eyebrow: '[ .V. .FUNDING. ]',
    title: 'Debt-funded MVP.\nZero dilution.',
    blurb:
      'Creative Growth Finance II (£500K) + grants + SEIS layered to retain 92–95% ownership through MVP. Path to Series B at £175M pre.',
    tag: 'Plan',
    accent: '#4A9B7F',
  },
  {
    slug: 'intel',
    num: 'VI',
    label: 'Market Intel',
    eyebrow: '[ .VI. .MARKET.INTEL. ]',
    title: 'What we see\nthat you do not.',
    blurb:
      'Fraud patterns, pricing signals, segment trends. Operational data from thousands of escrowed transactions across the £5K–£500K band.',
    tag: 'Data',
    accent: '#ff4d4d',
  },
  {
    slug: 'calculator',
    num: 'VII',
    label: 'Calculator',
    eyebrow: '[ .VII. .CALCULATOR. ]',
    title: 'Settlement\ncalculator.',
    blurb:
      'Live escrow simulation — tier multiplier, gallery markup, TF fee, 50/50 split, Xero invoice state, logistics chip, tri-party notifications.',
    tag: 'Tool',
    accent: '#13B5EA',
  },
  {
    slug: 'artist-cv',
    num: 'VIII',
    label: 'Artist CV',
    eyebrow: '[ .VIII. .CASE.STUDY. ]',
    title: 'Helena Foster.\nReference CV.',
    blurb:
      'Case-study artist used inside the calculator. Camberwell BA. Exhibitions: Kasmin NY, Simon Lee, French Riviera, Sid Motion. Tate Collective alumna.',
    tag: 'CV',
    accent: '#6B4226',
  },
  {
    slug: 'insolvency',
    num: 'IX',
    label: 'Insolvency Rights',
    eyebrow: '[ .IX. .LEGAL. ]',
    title: 'Know your rights.\nGallery insolvency.',
    blurb:
      'Wedlake Bell briefing (Feb 2026) on protecting artists when a gallery enters administration — termination, recovery, sale proceeds, proof of debt.',
    tag: 'Legal',
    accent: '#A47FDB',
  },
];
